export default "__VITE_ASSET__UZOR10GV__"